import React, { useState, useRef, useEffect } from "react"
import { Typography, Button, Badge, Input, message, useCRUDController, Row, Col, Card, Select, Divider } from "../../ui/ot"
// import { ChartTotalHoldings } from './chart_total_holdings'
import { ChartAccessioned } from "./chart_accessioned"
import { ChartIncreaseRate } from "./chart_increase_rate"
import { ChartCategoryAdditionTrend } from "./chart_category_addition_trend"
import { TableHoldingTotal } from "./table_holding_total"
import dayjs from 'dayjs';
import { BadgeInfo, Plus } from 'lucide-react';
import { ChartMonthlyAdditionTrend } from "./chart_monthly_addition_trend"

const basicFilterSetting = ["branchcode", 'itemtype']

const HoldingsAdded = ({
    filterSearchParams = [...basicFilterSetting]

}) => {
    const [searchParams, setSearchParams] = useState({
        item_type: null,
        branchcode: null,
    })
    const libraryController = useCRUDController({ apiRoute: "/koha/library" })
    const itemtypeController = useCRUDController({ apiRoute: "/koha/itemtypes" })
    useEffect(() => {
        libraryController.getData({})
        itemtypeController.getData({})
    }, []);
    return (<Row gutter={[4, 4]}>
        <Col span={24}>
            <Row align="middle">
                <Col>
                    <Plus className="h-5 w-5" />
                </Col>
                <Col>
                    <Typography.Title level={4}>
                        館藏增加量統計
                    </Typography.Title>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col span={24}>
                    <Row >
                        {filterSearchParams.includes("branchcode") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    分館篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.branchcode}
                                        value={searchParams?.branchcode}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    branchcode: value
                                                }
                                            })
                                        }}
                                        options={libraryController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.branchcode})${option?.branchname}`,
                                                value: option?.branchcode,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                        {filterSearchParams.includes("itemtype") ? <Col>
                            <Row align={"middle"} gutter={[8, 8]}>
                                <Col>
                                    館藏分類篩選：
                                </Col>
                                <Col>
                                    <Select
                                        allowClear={true}
                                        defaultValue={searchParams?.itemtype}
                                        value={searchParams?.itemtype}
                                        onChange={(value) => {
                                            setSearchParams((pre) => {
                                                return {
                                                    ...pre,
                                                    item_type: value
                                                }
                                            })
                                        }}
                                        options={itemtypeController?.ResponseData?.map((option) => {
                                            return {
                                                label: `(${option?.itemtype})${option?.description}`,
                                                value: option?.itemtype,
                                            }
                                        })}
                                    >
                                    </Select>
                                </Col>
                            </Row>
                        </Col> : <></>}
                    </Row>
                </Col>
                <Col span={24}>
                    <Row align="middle" gutter={[4, 4]}>
                        <Col>
                            <BadgeInfo size={16} />
                        </Col>
                        <Col>
                            <Typography.P>
                                透過調整館藏分館、館藏分類篩選，呈現館藏增加量與增長率
                            </Typography.P>
                        </Col>
                    </Row>
                </Col>
                <Col xxl={16} xl={16} lg={16} md={16} sm={16} xs={24}>
                    <Row gutter={[8, 8]}>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            <ChartAccessioned
                                propsDataParams={{
                                    time: dayjs().format("YYYY-MM-DD"),
                                    branchcode: searchParams?.branchcode,
                                    item_type: searchParams?.item_type
                                }}
                            />
                        </Col>
                        <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
                            <ChartAccessioned
                                propsDataParams={{
                                    time: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
                                    branchcode: searchParams?.branchcode,
                                    item_type: searchParams?.item_type
                                }}
                                propsLabel={"上月新增"}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col xxl={8} xl={8} lg={8} md={8} sm={8} xs={24}>
                    <ChartIncreaseRate
                        propsDataParams={{
                            ...searchParams,
                            start_time: dayjs().startOf("month").subtract(1, "month").format("YYYY-MM-DD"),
                            end_time: dayjs().endOf("month").format("YYYY-MM-DD")
                        }}
                    />
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Row gutter={[4, 4]}>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"月度新增趨勢"}
                        extra={"新增館藏數量長條圖"}
                    >
                        <ChartMonthlyAdditionTrend />
                    </Card>
                </Col>
                <Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                    <Card
                        title={"各類別新增趨勢"}
                    >
                        <ChartCategoryAdditionTrend />
                    </Card>
                </Col>
            </Row>
        </Col>
        <Col span={24}>
            <Card
                title={"館藏統計資料"}
            >
                <TableHoldingTotal
                    excelType={'increase'}
                    filterSearchParams={["branchcode", "time"]}
                />
            </Card>
        </Col>

    </Row>)
}
export { HoldingsAdded }